
import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchLeavesFulfilled = (state, action) => {
    state.status = 'succeeded';
    if (action?.payload?.data) {
         state.leaves = arrayToObjectCovert(action.payload.data);
        state.leavesOrder = action.payload.data.map(leave => leave.id);
        state.currentPage = action.payload.current_page;
        state.perPage = action.payload.limit;
        state.totalPages = action.payload.total_pages;
        state.totalLeaves = action.payload.total_leave_apply_count;
        state.lastUpdated = action.payload.last_updated;
        state.message = action.payload.message;
    } else {
        state.leaves = {};
        state.leavesOrder = [];
        state.currentPage = 1;
        state.perPage = 10;
        state.totalPages = 0;
        state.totalLeaves = 0;
        state.lastUpdated = null;
        state.message = '';
    }
};

const handleFetchLeaveByIdFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.currentLeave = action.payload.data;
};

const handleAddLeaveFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.message = action.payload.message;
};

const handleUpdateLeaveFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leaves[action.payload.data.id] = action.payload.data;
    state.currentLeave = action.payload.data;
    state.message = action.payload.message;
};

const handleFetchLeaveTypesFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leaveTypes = Array.isArray(action.payload?.data)
    ? action.payload.data
    : Object.values(action.payload?.data || {});
};

const handleWithdrawLeaveFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leaves[action.payload.data.id] = action.payload.data;
    state.message = action.payload.message;
};

const handleFetchLeaveBalanceFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leaveBalance = action.payload.data;
};

const handleFetchLeaveEligibilityCheckFulfilled = (state) => {
    state.status = 'succeeded';
}

const handleFetchReporteesLeavesFulfilled = (state, action) => {
    state.repoteesLeavesStatus = 'succeeded';
    state.repoteesLeaves = arrayToObjectCovert(action.payload.data);
    state.repoteesLeavesOrder = action.payload.data.map(leave => leave.id);
    state.repoteesLeavesCurrentPage = action.payload.current_page;
    state.repoteesLeavesPerPage = action.payload.limit;
    state.repoteesLeavesTotalPages = action.payload.total_pages;
    state.repoteesLeavesTotalLeaves = action.payload.total_leave_apply_count;
    state.repoteesLeavesLastUpdated = action.payload.last_updated;
    state.repoteesLeavesMessage = action.payload.message;
};

const handleReposteesLeaveStatusChangeFulfilled = (state, action) => {
    state.repoteesLeavesStatus = 'succeeded';
    action.payload.data.leave_apply_ids.forEach(updatedLeave => {
        state.leaves[updatedLeave] = updatedLeave;
    });
    state.repoteesLeavesMessage = action.payload.message;
};

const handleReposteesIndividualLeaveStatusChangeFulfilled = (state, action) => {
    state.repoteesLeavesStatus = 'succeeded';
    state.leaves[action.payload.data.leave_apply_id] = action.payload.data;
    state.repoteesLeavesMessage = action.payload.message;
};

const handleFetchReportLeaveHistoryFulfilled = (state, action) => {
    state.reportLeaveHistoryStatus = 'succeeded';
    state.reportLeaveHistory = action.payload.data;
    state.reportLeaveHistoryCurrentPage = action.payload.current_page;
    state.reportLeaveHistoryPerPage = action.payload.limit;
    state.reportLeaveHistoryTotalPages = action.payload.total_pages;
    state.reportLeaveHistoryTotalLeaves = action.payload.total_leaves_count;
    state.reportLeaveHistoryLastUpdated = action.payload.last_updated;
    state.reportLeaveHistoryMessage = action.payload.message;
};

const handleFetchScheduleComplianceListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.scheduleComplianceList = action.payload.data;
    state.scheduleComplianceListCurrentPage = action.payload.current_page;
    state.scheduleComplianceListPerPage = action.payload.limit;
    state.scheduleComplianceListTotalPages = action.payload.total_pages;
    state.scheduleComplianceListTotalLeaves = action.payload.total_count;
    state.scheduleComplianceListLastUpdated = action.payload.last_updated;
    state.message = action.payload.message;
}

const handleManualUpdateLeaveFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.message = action.payload.message;
};

export {
    handleFetchLeavesFulfilled,
    handleFetchLeaveByIdFulfilled,
    handleAddLeaveFulfilled,
    handleUpdateLeaveFulfilled,
    handleFetchLeaveTypesFulfilled,
    handleFetchLeaveBalanceFulfilled,
    handleWithdrawLeaveFulfilled,
    handleFetchReporteesLeavesFulfilled,
    handleReposteesLeaveStatusChangeFulfilled,
    handleReposteesIndividualLeaveStatusChangeFulfilled,
    handleFetchReportLeaveHistoryFulfilled,
    handleManualUpdateLeaveFulfilled,
    handleFetchScheduleComplianceListFulfilled,
    handleFetchLeaveEligibilityCheckFulfilled
};
